

import { Options, Vue } from 'vue-class-component';
import { ModalBus } from './modalBus';
import { ModalInput } from './classes'

@Options({})
export default class ModalsContainer extends Vue {

    items: ModalInput[] = [];

    created(){
        ModalBus.registerAddModalCallback((item, props, closeCallback = null) => {
            setTimeout(() => {
                this.items.push({
                    modalComponent: item,
                    props: props,
                    closeCallback: closeCallback
                })
            }, 200);
            document.body.classList.add('__modal-open');

            const layoutElement = (<any>document.querySelector('.layout'));
                
            if(layoutElement)
                layoutElement.inert = true;
        })
        ModalBus.registerCloseLastModal(this.closeLastModal);
        ModalBus.setModalsArray(this.items);
    }

    hasMouseDown: boolean = false;
    onDownBg(ev, i){
        if(ev.target == this.$refs['__modalBg' + i]){
            this.hasMouseDown = true;
        }
    }
    onUpBg(ev, i){
        if(this.hasMouseDown){
            this.hasMouseDown = false;
            if(ev.target == this.$refs['__modalBg' + i]){
                this.closeLastModal();
            }
        }
    }

    closeModal(index){
        let removed = this.items.splice(index, 1)[0];
        if(removed.closeCallback){
            removed.closeCallback();
        }
        if(this.items.length == 0){
            document.body.classList.remove('__modal-open');
            (<any>document.querySelector('.layout')).inert = false;
        }
    }
    closeFromBg(ev){
        this.closeLastModal();
    }
    closeLastModal(){
        let removed = this.items.pop();
        if(removed.closeCallback){
            removed.closeCallback();
        }
        if(this.items.length == 0){
            document.body.classList.remove('__modal-open');
            (<any>document.querySelector('.layout')).inert = false;
        }
    }

}
